/** Breakpoints (px) del masonry de Radar. Deben coincidir con los estilos de los componentes. */
export const RADAR_COLUMN_BREAKPOINTS = [
    { minWidth: 1024, columnCount: 3 },
    { minWidth: 768, columnCount: 2 }
]

export const RADAR_DEFAULT_COLUMN_COUNT = 1

/** Calcula el número máximo de columnas según el ancho de ventana. */
export const resolveColumnCountForWidth = (width) => {
    const breakpoint = RADAR_COLUMN_BREAKPOINTS.find((candidate) => width >= candidate.minWidth)

    return breakpoint ? breakpoint.columnCount : RADAR_DEFAULT_COLUMN_COUNT
}

/** Número de columnas según el viewport actual; en SSR o sin window usa el default mobile-first. */
export const resolveInitialColumnCount = () => {
    if (typeof window === 'undefined') {
        return RADAR_DEFAULT_COLUMN_COUNT
    }

    return resolveColumnCountForWidth(window.innerWidth)
}

/** Evita columnas vacías: no se piden más columnas que ítems disponibles. */
export const resolveEffectiveColumnCount = (viewportColumnCount, itemCount) => {
    return Math.min(viewportColumnCount, Math.max(itemCount, 1))
}
